import React from 'react';
export function HEMSection() {
  return <section data-id="element-2876">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-2877">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-2878">
          High-Efficiency Machining (HEM)
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-2879">
        <div className="grid md:grid-cols-3 gap-8 items-start" data-id="element-2880">
          <div className="md:col-span-2 space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-2881">
            <p data-id="element-2882">
              HEM has evolved from a philosophy that takes advantage of the
              maximum amount of work that a tool can perform. Considerations for
              chip thinning and feed rate adjustment are used so that each
              cutting edge of a tool takes a consistent chip thickness with each
              rotation, even at varying radial depths of cut and while
              interpolating around curves. This allows machinists the
              opportunity to utilize a radial depth of cut that more effectively
              uses the full potential of a given tool. Utilizing the entire
              available length of cut allows tool wear to be spread over a
              greater area, prolonging tool life and lowering production costs.
            </p>
            <p data-id="element-2883">
              Effectively, HEM uses the depths associated with a traditional
              finishing operation but boosts speeds and feeds, resulting in much
              higher material removal rates (MRR). This technique is typically
              used for hogging out large volumes of material in roughing and
              pocketing applications.
            </p>

            <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mt-6" data-id="element-2884">
              <p className="mb-4" data-id="element-2885">
                High Efficiency Milling (HEM) is a strategy that continues to
                gain popularity in the metalworking industry, and most CAM
                packages now offer modules to generate HEM toolpaths, each with
                their own proprietary name. In these packages, HEM can also be
                known as Dynamic Milling or High Efficiency Machining, among
                others.
              </p>
              <p className="font-bold text-navy mb-2" data-id="element-2886">HEM can result in:</p>
              <ul className="list-disc list-inside space-y-1 mb-4 ml-2" data-id="element-2887">
                <li data-id="element-2888">profound shop efficiency</li>
                <li data-id="element-2889">extended tool life</li>
                <li data-id="element-2890">greater performance</li>
                <li data-id="element-2891">and cost savings.</li>
              </ul>
              <p data-id="element-2892">
                High performance end mills designed to achieve higher speeds and
                feeds will help machinists to reap the full benefits of this
                popular machining method.
              </p>
            </div>
          </div>

          <div className="md:col-span-1 space-y-6 bg-gray-50 p-6 rounded-lg border border-gray-200 text-center" data-id="element-2893">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/MILL%20E/Mikron%20MILL%20E%20500%20U.png" alt="Mikron MILL E 500 U" className="mx-auto h-auto max-w-full block" data-id="element-2894" />
            <p className="text-sm text-gray-600 leading-relaxed text-left" data-id="element-2895">
              Efficient production and fast return on investment reach a new
              level with the Mikron MILL E 500 U and its larger counterpart, the
              Mikron MILL E 700 U, the latest five-axis, high-efficiency Milling
              solutions from GF Machining Solutions. Manufacturers of small to
              medium batches of parts can experience first-hand how the Mikron
              MILL E 500 U delivers the best price/performance ratio essential
              to achieving competitive cost per part.
            </p>
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/MILL%20E/Mikron%20MILL%20E%20Construction%20Benefits.png800x800.png" alt="Mikron MILL E Construction Benefits" className="mx-auto h-auto max-w-full rounded-lg block" data-id="element-2896" />
            <div className="pt-4 border-t border-gray-200" data-id="element-2897">
              <p className="font-bold text-sm text-gray-500 mb-2" data-id="element-2898">MORE INFO:</p>
              <a href="59m7/gf-machining-solutions/mikron-high-speed-3-5-axis-milling/efficiency.html" target="_blank" rel="noopener noreferrer" className="text-[#0c79c8] hover:underline font-bold" data-id="element-2899">
                GF Machining Solutions Mikron MILL E U High-Efficiency Machining
                Centers
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}